import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const comboBoxStyled = "omponents__UniversalSearch__UniversalSearch_styled_tsx-comboBoxStyled-c1hjlni7";
export const selectedModelStyled = "omponents__UniversalSearch__UniversalSearch_styled_tsx-selectedModelStyled-s1yliocz";
export const searchModalStyled = "omponents__UniversalSearch__UniversalSearch_styled_tsx-searchModalStyled-shepncz";

require("./UniversalSearch.styled.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./UniversalSearch.styled.tsx");